import React from 'react';
/** Brand name that never splits across lines. */
export function Brand({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`brand whitespace-nowrap ${className}`} data-id="element-56" data-mp="16b3ht1ltqfau">音樂備課寶™</span>;
}